import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconShoppingBag_13 = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H22.3337C22.7479 11.25 23.0837 11.5858 23.0837 12V30.5719C23.0837 30.9861 22.7479 31.3219 22.3337 31.3219H5C4.58579 31.3219 4.25 30.9861 4.25 30.5719V12ZM5.75 12.75V29.8219H21.5837V12.75H5.75Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.8219 16.2856C21.8219 15.8714 22.1577 15.5356 22.5719 15.5356H28.0482C28.3323 15.5356 28.592 15.6961 28.7191 15.9502L31.4645 21.4411L34.0981 22.7579C34.3522 22.8849 34.5127 23.1446 34.5127 23.4287V30.5717C34.5127 30.9859 34.1769 31.3217 33.7627 31.3217H22.0957C21.6815 31.3217 21.3457 30.9859 21.3457 30.5717C21.3457 30.1575 21.6815 29.8217 22.0957 29.8217H33.0127V23.8922L30.57 22.6709C30.4249 22.5983 30.3072 22.4806 30.2346 22.3355L27.5847 17.0356H22.5719C22.1577 17.0356 21.8219 16.6999 21.8219 16.2856Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.0941 30.5717C13.0941 31.8867 12.028 32.9527 10.713 32.9527C9.39805 32.9527 8.33203 31.8867 8.33203 30.5717C8.33203 29.2567 9.39805 28.1907 10.713 28.1907C12.028 28.1907 13.0941 29.2567 13.0941 30.5717Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.713 28.9407C9.81226 28.9407 9.08203 29.6709 9.08203 30.5717C9.08203 31.4725 9.81226 32.2027 10.713 32.2027C11.6138 32.2027 12.3441 31.4725 12.3441 30.5717C12.3441 29.6709 11.6138 28.9407 10.713 28.9407ZM7.58203 30.5717C7.58203 28.8425 8.98383 27.4407 10.713 27.4407C12.4423 27.4407 13.8441 28.8425 13.8441 30.5717C13.8441 32.3009 12.4423 33.7027 10.713 33.7027C8.98383 33.7027 7.58203 32.3009 7.58203 30.5717Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M30.43 30.5717C30.43 31.8867 29.364 32.9527 28.049 32.9527C26.734 32.9527 25.668 31.8867 25.668 30.5717C25.668 29.2567 26.734 28.1907 28.049 28.1907C29.364 28.1907 30.43 29.2567 30.43 30.5717Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.049 28.9407C27.1482 28.9407 26.418 29.6709 26.418 30.5717C26.418 31.4725 27.1482 32.2027 28.049 32.2027C28.9498 32.2027 29.68 31.4725 29.68 30.5717C29.68 29.6709 28.9498 28.9407 28.049 28.9407ZM24.918 30.5717C24.918 28.8425 26.3198 27.4407 28.049 27.4407C29.7782 27.4407 31.18 28.8425 31.18 30.5717C31.18 32.3009 29.7782 33.7027 28.049 33.7027C26.3198 33.7027 24.918 32.3009 24.918 30.5717Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16.5 12.75C16.5 17.0302 13.0302 20.5 8.75 20.5C4.46979 20.5 1 17.0302 1 12.75C1 8.46979 4.46979 5 8.75 5C13.0302 5 16.5 8.46979 16.5 12.75Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.65576 16.375H7.26997V9.25052H5.85504L4.21094 10.4163V11.7914L5.65576 10.8448V16.375Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.9036 16.4846C12.6374 16.4846 13.6637 15.6376 13.6637 14.3024C13.6637 13.3957 13.1057 12.8078 12.2787 12.6284C12.9861 12.3793 13.4544 11.8811 13.4544 11.084C13.4544 9.96795 12.5377 9.15088 10.9733 9.15088C9.34916 9.15088 8.42248 10.1075 8.34277 11.4128H9.76766C9.84738 10.7452 10.2659 10.3366 10.9434 10.3366C11.6011 10.3366 11.9299 10.7153 11.9299 11.2235C11.9299 11.8313 11.5911 12.1701 10.8438 12.1701H10.3257V13.2462H10.8837C11.6509 13.2462 12.0296 13.595 12.0296 14.2725C12.0296 14.9102 11.6509 15.2988 10.8438 15.2988C9.98688 15.2988 9.6182 14.8006 9.55841 14.1131H8.10363C8.16341 15.5579 9.09009 16.4846 10.9036 16.4846Z",
        fill: "white"
    }));

export { IconShoppingBag_13 };
